module.exports = __webpack_public_path__ + "img/icon-Social6.426426ad.png";